/**
 * TelasIds
 */

export enum TelasIds {
  Habilidades = 1,
  Funcionarios,
  Treinamentos,
  GestaoDeTreinamentosRH,
  ControleDePatrimonio,
  GestaoDeTreinamentosTerceirizacao,
  GestaoDeImpressao,
  GestaoDeRevisao,
  AcoesCorretivas_cadastro,
  AcoesCorretivas_lista,
  AcoesPreventivas_cadastro,
  AcoesPreventivas_lista,
  AssistenciaTecnica_cadastro,
  AssistenciaTecnica_lista,
  AtributosCompras_cadastro,
  AtributosObras_cadastro,
  AtributosSistema_cadastro,
  Auditores_cadastro,
  Auditores_lista,
  Auditorias_cadastro,
  Auditorias_lista,
  AvaliacaoFornecedor_cadastro,
  AvaliacaoFornecedor_Multipla,
  AvaliacaoTreinamentoLote_cadastro,
  AvaliacaoTreinamentoLoteTerceirizacao_cadastro,
  AvalicaoHabilidade_cadastro,
  BancoPagamento_lista,
  Biblioteca_cadastro,
  Biblioteca_lista,
  CadastroAssinaturas_lista,
  CadastroPesquisa_lista,
  CadastroPesquisaItens_cadastro,
  Cargos_cadastro,
  Cargos_lista,
  CategoriaAssistencia_lista,
  CentroCusto_cadastro,
  CentroCusto_lista,
  Checklist_lista,
  ChecklistEntrega_lista,
  ChecklistEntregaItens_cadastro,
  ChecklistItens_cadastro,
  ChecklistServico_grafico,
  ChecklistServico_item,
  ChecklistServico_lista,
  ChecklistServico_obrasItem,
  ChecklistServicoItens_cadastro,
  Clientes_cadastro,
  Clientes_lista,
  ColetaPrecos_cadastro,
  ColetaPrecos_lista,
  ContasPagar_cadastro,
  ContasPagar_deletadas,
  ContasPagar_lista,
  ContasReceber_cadastro,
  ContasReceber_deletadas,
  ContasReceber_lista,
  Contrato_cadastro,
  Contrato_lista,
  ControleBiblioteca_cadastro,
  ControleBiblioteca_lista,
  ControleEstoque_cadastro,
  ControleEstoque_lista,
  ControleMateriais_lista,
  ControlePatrimonio_cadastro,
  ControlePatrimonio_lista,
  ControleServicos_lista,
  CronogramaItensChecklist_cadastro,
  CronogramaSGQ_lista,
  Default,
  DiarioObra_cadastro,
  DiarioObra_lista,
  Empreendimento_cadastro,
  Empreendimento_lista,
  EntradaProdutos_cadastro,
  EntradaProdutos_cadastromultiplo,
  EntradaProdutos_lista,
  EntregaObras_lista,
  EntregaObrasCliente_lista,
  EntregaObrasCliente_verificacao,
  EquipamentoMedicao_lista,
  FinanceiroContratos_cadastro,
  FinanceiroContratos_lista,
  FinanceiroReajuste_cadastro,
  FinanceiroReajustes_lista,
  FolhaPagamento_cadastro,
  FolhaPagamento_itensverba,
  FolhaPagamento_lista,
  Fornecedor_avaliacao,
  Fornecedores_cadastro,
  Fornecedores_lista,
  Funcionarios_cadastro,
  Funcionarios_lista,
  FuncionarioTercerizacao_cadastro,
  FuncionarioTercerizacao_lista,
  GED_auditoria,
  GED_biblioteca,
  GED_comercial,
  GED_compras,
  GED_entregaobras,
  GED_equipamentomedicao,
  GED_externos,
  GED_financeiro,
  GED_internos,
  GED_maquinasequip,
  GED_obras,
  GED_projetos,
  GED_qualidade,
  GED_rh,
  GED_terceirizacao,
  GestaoTreinamentos_cadastro,
  GestaoTreinamentos_lista,
  GestaoTreinamentosTerceirizacao_cadastro,
  GestaoTreinamentosTerceirizacao_lista,
  GruposAcesso_cadastro,
  GruposAcesso_lista,
  HabilidadeCargo_cadastro,
  Habilidades_lista,
  Impressao_cadastrogerenciar,
  Impressao_cadastrosolicitar,
  Impressao_listagerenciar,
  Impressao_listasolicitar,
  Indicadores_lista,
  MaquinasEquip_cadastroprincipal,
  MaquinasEquip_controle,
  MaquinasEquip_lista,
  MaquinasEquip_verificacao,
  MaquinasEquipItens_cadastro,
  MaquinasEquipItens_controle,
  MaquinasEquipItens_verificacao,
  MedicaoTerceirizacao_avaliacafornecimento,
  MedicaoTerceirizacao_cadastro,
  MedicaoTerceirizacao_entrega,
  MedicaoTerceirizacao_lista,
  MotivoAfastamento_lista,
  MotivoDemissao_lista,
  NovosNegocios_cadastro,
  NovosNegocios_lista,
  ObraItensChecklistArea_cadastro,
  ObraItensChecklistArea_verificacao,
  ObraItensChecklistServico_cadastro,
  ObraItensChecklistServico_verificacao,
  Obras_alvenariaestrutural,
  Obras_cadastro,
  Obras_cadastroarea,
  Obras_checklistarea,
  Obras_checklistservicos,
  Obras_checklistsituacao,
  Obras_concretagem,
  Obras_equipamentosmedicao,
  Obras_gestao_servicos,
  Obras_gestaoresiduos,
  Obras_informacoesgerais,
  Obras_lista,
  Obras_maquinasequipamentos,
  Obras_materiaiscontrolados,
  Obras_servicoscontrolados,
  Obras_sustentabilidade,
  Obras_treinamentos,
  OrdemCompra_cancelar,
  OrdemCompra_consultarPrecos,
  OrdemCompra_lista_cancelar,
  OrdemCompras_cadastro,
  OrdemCompras_entrega,
  OrdemCompras_lista,
  PermissaoAcesso_cadastro,
  PesquisaAssistenciaTecnica_verificacao,
  PesquisaCliente_lista,
  PesquisaCliente_verificacao,
  PesquisaEntregaObra_verificacao,
  Pivot_ContasPagarReceber,
  Planejamento_cadastro,
  Planejamento_lista,
  Principal_auditoria,
  Principal_biblioteca,
  Principal_comercial,
  Principal_compras,
  Principal_controledocumentos,
  Principal_diarioObra,
  Principal_entregaobra,
  Principal_equipamentomedicao,
  Principal_financeiro,
  Principal_maquinasequip,
  Principal_obras,
  Principal_projetos,
  Principal_qualidade,
  Principal_RH,
  Principal_terceirizacao,
  ProcessosRiscos_cadastroitens,
  ProcessosRiscos_lista,
  ProcessosRiscos_listaitens,
  Projetos_cadastro,
  Projetos_lista,
  ProvisaoRecurso_lista,
  RateioGeral_cadastro,
  RateioGeral_lista,
  RequisicaoServicosProdutos_cadastro,
  RequisicaoServicosProdutos_lista,
  Revisao_cadastrogerenciar,
  Revisao_cadastrosolicitar,
  Revisao_listagerenciar,
  Revisao_listasolicitar,
  SaidaProdutos_cadastro,
  SaidaProdutos_cadastromultiplo,
  SaidaProdutos_lista,
  SaldoBancario_cadastro,
  SaldoBancario_lista,
  SatisfacaoClientePesquisa_lista,
  SegurancaTrabalho_cadastro,
  SegurancaTrabalho_lista,
  ServicosProdutos_lista,
  Subcontas_lista,
  Termo_lista,
  TreinamentoCargo_cadastro,
  TreinamentoFuncionario_cadastro,
  TreinamentoFuncionarioTerceirizacao_cadastro,
  Treinamentos_lista,
  Usuarios_cadastro,
  Usuarios_lista,
  VerbaPagamento_lista,
  Termo_epi
}

/**
 * telaIdsToNumber
 */

export function telaIdsToNumber(telaId: TelasIds): number {
  return telaId as number;
}